module.exports = __webpack_public_path__ + "img/img2.b78cd992.jpg";